import React, { Component } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../il8n/lang';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import './Collectioncaro.css';
import { collectionServer, cdnBase, breakSmall } from "../../const";
import { changeCollectibles, changeHaveIt, changeWantIt, changeFlip } from "../../Actions/Index.js";
import { goFetch } from '../../utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faArrowRight, faArrowLeft, faHeart, faCheck, faRedo, faTimes } from '@fortawesome/free-solid-svg-icons'

import _ from 'lodash';
/**
 * Collection
 * @constructor
 */

class Collectioncaro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      q: '',
      filters: {
        page: 1,
        count: 12,
        attributes: {}
      },
      toggleSeasons: false, 
      filterOptions: {},
      selectedTags: [],
      collectionlimit: 4,
      ...props
    };
    this.populateCollection = this.populateCollection.bind(this);

  }
  componentWillMount() {

    this.populateCollection();
    window.addEventListener('resize', this.onResize, false);
    this.throttledResize = _.throttle(this.throttledResize.bind(this), 500);
    this.onResize();
  }

   /**
  }
  * Tied to the resize event on window
  */
  onResize = (e) => {
    this.throttledResize(e);
  }
  /**
  * Throttled resize function, handles resetting slidesToShow count
  */
  throttledResize = (e) => {
    // console.log('flsdjhl')
    this.setState({
      collectionlimit: window.innerWidth < breakSmall ? 1 : 4
    });

  }
  /* Renderable
  ------------------------------------- */
  /**
  * Get the Collection item Attributes
  * @param {obj} attributes
  * @returns {jsx} Individual collection attributes
  */
  getCollectionAttributes(attributes){
    let attr = [];
    for(let attribute in attributes){
      if(attribute !== 'image' && attribute !== 'subsection' && attribute !== 'series' && attribute !== 'babies'){
        attr.push(
          <span key={`attribute-${attribute}`}>
            <dt>{attribute}:</dt>
            <dd>{attributes[attribute]}</dd>
          </span>
        );
      }
    }
    return(attr);
  }
  /**
  * Create ID
  * @param {name} name - Collectible ID
  * @returns {string} Collectible ID
  */
  getCollectibleID(name){
    let collectibleID = name.split(' ').join('_').split('-').join('_').toLowerCase();
    return collectibleID;
  }
  /**
  * Render Have It / Want It Buttons
  * @param {string} name - Collectible Name
  * @returns {jsx} Have It / Want It Buttons
  */
  getHaveItWantIt(name, back){
    const { haveIt, wantIt, flipIt } = this.props;
    let collectibleId = this.getCollectibleID(name);
    let arrow = <FontAwesomeIcon icon={faArrowRight} />
    if (back) 
      arrow = <FontAwesomeIcon icon={faArrowLeft} />
    return(
      <div className='haveitwantit'>
        <div className={`btn-havewant ${haveIt.includes(name) ? 'active' : ''}`} onClick={() => this.props.dispatch(changeHaveIt(name))}>
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <span className="haveitwantit__label">{lang.collection.haveIt}</span>
        <div className={`btn-havewant ${wantIt.includes(name) ? 'active' : ''}`} onClick={() => this.props.dispatch(changeWantIt(name))}>
          <FontAwesomeIcon icon={faHeart} />
        </div>
        <span className="haveitwantit__label">{lang.collection.wantIt}</span>

        <div 
        className={`btn-havewant ${flipIt.includes(name) ? 'active' : ''}`} 
        onClick={() => this.props.dispatch(changeFlip(name))}
        >
          {arrow}
          
        </div>
        <span className="haveitwantit__label">{lang.collection.flipIt}</span>
      </div>
    );
  }
  /**
  * Render all Collectibles
  * @returns {jsx} All collectibles
  */
  renderCollectibles(){

    const {collectibles, haveIt, wantIt, flipIt } = this.props;

    // if(){

    // }

    return(
      <div className='collection-row'>
        {
          collectibles.collectibles.map((collectible, index) => {
            if (index < this.state.collectionlimit) {
              return(
                <div className={`collection-item ${flipIt.includes(collectible.name + index) ? 'flipped' : ''}`} key={`collectible-${index}`}>
                  <div className='collection-item__inner'>
                    <div className='collection-item__inner__front'>
                      <div className='collection-item__inner__front__img'>
                        <img src={`${collectible.attributes.image}`} alt={collectibles.name}/>

                      </div>
                      <div className='collection-item__inner__front__desc'>
                        
                        { this.getHaveItWantIt(collectible.name + index) }
                      </div>
                     
                    </div>
                    <div className="collection-item__inner__back">
                      <div className='collection-item__inner__back__attributes'>
                        <dl>
                          {this.getCollectionAttributes(collectible.attributes)}
                        </dl>
                      </div>
                      <div className='collection-item__inner__front__desc'>
                        
                        { this.getHaveItWantIt(collectible.name + index, 'back') }
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            
          })
        }
      </div>
    );
  }

  /**
   * Populate the collection list - Dispatches an action using params based on local state.
   */
   populateCollection(){
     let {filters, q} = this.state;
     let qs = q === '' ? '' : `?${q}`;
     // console.log('en_us',filters)
     let feedUrl = `${collectionServer}${lang.getLanguage()}/1/4`;
     goFetch('get', feedUrl).then((res) => {
       if(res.error){
         console.error(res.message);
       } else {
         this.props.dispatch(changeCollectibles(res));
       }
     });

   }

  render() {
    let {collectibles, haveIt, wantIt, flipIt } = this.props;
    if(lang.home.sections.collection){
      return (
        <div className="flex-container">
          <div className="flex-row">
            <h1>{lang.home.sections.collection.heading}</h1>
            
          </div>
          <div className="flex-row"> 
            <h2>{lang.home.sections.collection.subheading[0]} : <span>{lang.home.sections.collection.subheading[1]}</span></h2>
  
          </div>
          <div className="flex-row">
          <Link to={ `/${lang.getLanguage()}/collection`} >
            <button className="btn_light">{lang.home.sections.collection.button}</button>
          </Link> 
          </div>
          <div className="flex-row">
            {collectibles.collectibles ? this.renderCollectibles() : <div className="loading">{lang.loading}</div>}
          </div>
          
  
        </div>
      )
    }else{
      return(
        <div>there is no collection section</div>
      )
    }
    
  }
}

function mapStateToProps(state) {
  let { lang, collectibles, haveIt, wantIt, flipIt } = state;

  return {
    lang,
    collectibles,
    haveIt,
    wantIt,
    flipIt
  };
}

export default connect(mapStateToProps)(Collectioncaro);



// WEBPACK FOOTER //
// ./src/components/Collectioncaro/Collectioncaro.js